import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

export function ProtectedRoute({ children, adminOnly = false }) {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <Loader2 className="w-10 h-10 animate-spin text-primary mx-auto mb-4" />
          <p className="text-muted-foreground">Cargando...</p>
        </div>
      </div>
    );
  }

  // En modo cierre: Solo admins pueden acceder a rutas protegidas
  // Usuarios normales son redirigidos al home para ver info de devoluciones
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Si no es admin, redirigir al home con mensaje de devolución
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
